import { render, staticRenderFns } from "./BonusDetailPopup.vue?vue&type=template&id=628c59c6&scoped=true&"
import script from "./BonusDetailPopup.vue?vue&type=script&lang=js&"
export * from "./BonusDetailPopup.vue?vue&type=script&lang=js&"
import style0 from "./BonusDetailPopup.vue?vue&type=style&index=0&id=628c59c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c59c6",
  null
  
)

export default component.exports